export default __webpack_public_path__ + "238cd2632337dbb769ac56a66c32edb8.png";